import { Injectable } from '@angular/core';
import { Config } from '../../../infrastructure/config';
import { CreateCartRequestModel } from '../../../models/requestModels/cart/createCartModel';
import { AddCartLine } from '../../../models/requestModels/cart/addCartLine';
import { UpdateCartLineAmountModel } from '../../../models/requestModels/cart/updateCartLineAmountModel';
import { HttpClient } from '@angular/common/http';
import { Cart } from 'src/models/DTO/cart/cart';
import { WholeCart } from 'src/models/DTO/cart/wholeCart';


@Injectable({
  providedIn: 'root'
})
export class CartService {

  private cartURL: string = Config.api + "cart";
  private currentCartURL: string = Config.api + "cart/current?include=sku";
  private cartLineURL: string = Config.api + "cart/";


  constructor( private httpclient: HttpClient
  ) {  }

  public createCart(createCartModel: CreateCartRequestModel) {
    return this.httpclient.post(this.cartURL, createCartModel);
  }

  public getCurrentCart() {
    return this.httpclient.get<WholeCart>(this.currentCartURL);
  }


  public addCartLine(cartUUID: string, addCartLine: AddCartLine) {
    return this.httpclient.post(this.cartLineURL + cartUUID + '/lines/add', addCartLine);
  }


  public deleteCartLine(cartUUID: string, lineUUID: string) {
    return this.httpclient.delete(this.cartLineURL + cartUUID + '/lines/remove/' + lineUUID);
  }

  public updateCartLine(cartUUID: string, cartLineUpdateModel: UpdateCartLineAmountModel) {
    return this.httpclient.put(this.cartLineURL + cartUUID + '/lines/update-quantity', cartLineUpdateModel);
  }
}
